// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bl_dC";
export var articleInfoItem = "bl_dD";
export var itemChild = "bl_dF";